const loadFile = () => {

    const loadBlock     = document.querySelectorAll('[data-btn="load-file"]'),
          removeFileBtn = document.querySelectorAll('[data-btn="remove-file"]');

    try {
        loadBlock.forEach(item => {
            
            item.addEventListener('click', ()=>{
                let hiddenInput = item.closest('.load-file-input').querySelector('[data-input="load-file"]'),
                    inputText   = item.closest('.load-file-input').querySelector('.input_fake .span'),
                    inputFake   = item.closest('.load-file-input').querySelector('.input_fake');

                hiddenInput.click();

                hiddenInput.addEventListener('input', ()=>{
                    inputText.textContent = hiddenInput.files[0].name;

                    if(hiddenInput.value != '') {
                        inputFake.classList.add('active');
                    } else {
                        inputFake.classList.remove('active');
                    }
                });

            });
        });
    } catch(e){}

    try {
        removeFileBtn.forEach(item => {
            item.addEventListener('click', ()=>{
                item.closest('.load-file-input').querySelector('[data-input="load-file"]').value = '';
                item.closest('.load-file-input').querySelector('.input_fake').classList.remove('active');
                item.closest('.load-file-input').querySelector('.span').textContent = 'Прикрепить файл';
            });
        });
    } catch(e){}
};

export default loadFile;